<template>
  <div class="account-page">
    <div class="section-title">{{ $t('message.home.accountInfo') }}</div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" v-loading="loading" style="max-width:480px">
      <el-form-item :label="$t('message.home.nickname')" prop="username">
        <el-input v-model="form.username" :placeholder="$t('message.home.enterNickname')" />
      </el-form-item>
      <el-form-item :label="$t('message.home.gender')" prop="gender">
        <el-radio-group v-model="form.gender">
          <el-radio :label="1">{{ $t('message.home.male') }}</el-radio>
          <el-radio :label="2">{{ $t('message.home.female') }}</el-radio>
          <el-radio :label="0">{{ $t('message.home.secret') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('message.home.birthday')" prop="birthday">
        <el-date-picker v-model="form.birthday" type="date" value-format="yyyy-MM-dd"
          :placeholder="$t('message.home.selectDate')" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('message.home.email')" prop="email">
        <el-input v-model="form.email" :placeholder="$t('message.home.enterEmail')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSave" :loading="saving">{{ $t('message.home.save') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { load_member, update } from '@/api/upms/profile'

export default {
  name: 'AccountInfo',
  data() {
    return {
      loading: false, saving: false,
      form: { username: '', gender: 0, birthday: '', email: '' },
      rules: {
        username: [{ required: true, message: this.$t('message.home.required'), trigger: 'blur' }]
      }
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      load_member().then(r => {
        const m = r.data?.data?.member || {}
        const gv = m.gender != null && typeof m.gender === 'object' && m.gender.value !== undefined
          ? m.gender.value : m.gender
        let gender = 0
        if (gv === 0 || gv === 'MALE') gender = 1
        else if (gv === 1 || gv === 'FEMALE') gender = 2
        let birthday = ''
        if (m.birth) {
          const dt = new Date(m.birth)
          if (!isNaN(dt.getTime())) {
            const y = dt.getFullYear()
            const mo = String(dt.getMonth() + 1).padStart(2, '0')
            const da = String(dt.getDate()).padStart(2, '0')
            birthday = `${y}-${mo}-${da}`
          }
        }
        this.form = {
          username: m.username || '',
          gender,
          birthday,
          email: m.email || ''
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        update(this.form).then(() => {
          this.$message.success(this.$t('message.home.saveSuccess'))
          this.saving = false
        }).catch(() => { this.saving = false })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.account-page { padding: 8px 0; }
.section-title { font-size: 18px; font-weight: bold; margin-bottom: 24px; color: #303133; }
</style>
